// extracted by mini-css-extract-plugin
export default {"filter_wrap":"Panel_filter_wrap__DujnC","selected":"Panel_selected__eOg6s","f":"Panel_f__BxOPl","slider_wrap":"Panel_slider_wrap__bHlno","info":"Panel_info__ruqch"};